import { render, staticRenderFns } from "./lifeHelp.vue?vue&type=template&id=3e54cd35&scoped=true&"
import script from "./lifeHelp.vue?vue&type=script&lang=js&"
export * from "./lifeHelp.vue?vue&type=script&lang=js&"
import style0 from "./lifeHelp.vue?vue&type=style&index=0&id=3e54cd35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54cd35",
  null
  
)

component.options.__file = "lifeHelp.vue"
export default component.exports